// Import helpers
import { CUSTOM_ERROR } from 'helpers/error_code_api';

// Define variables
const { CUSTOM_INVALID_VAT_NUMBER } = CUSTOM_ERROR;
const FORMIK_VAT_NUMBER_FIELD = 'vat_number';
const API_VAT_NUMBER_VALIDATOR_KEY = 'client.vat_number';

export const handleVatNumberError = (error, setFieldError) => {
	const vatNumberError =
		error?.response?.data?.validator?.errors[`${API_VAT_NUMBER_VALIDATOR_KEY}`];

	const isVatNumberError = !!vatNumberError?.length;

	if (isVatNumberError) {
		setFieldError(FORMIK_VAT_NUMBER_FIELD, CUSTOM_INVALID_VAT_NUMBER);
	}
};
